module.exports = __webpack_public_path__ + "static/media/unknown-man.01f44457.svg";